import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class PurchaseLogWorkOrderService extends Service {
	constructor(injector: Injector) {
		super("PurchaseLogWorkOrder", injector);
	}

	// API
	forPurchaseLog(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForPurchaseLog/${id}`);
	}

	forWorkOrder(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForWorkOrder/${id}`);
	}
}